/** Global Alt+1..4 shortcuts to main app pages (see ALL_NAV_PAGES order). */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ALL_NAV_PAGES } from '@/components/layout/appBarHeaderNav';

const isEditableFocused = () => {
  const activeElement = document.activeElement;
  if (!activeElement || !(activeElement instanceof HTMLElement)) return false;
  return (
    activeElement.tagName === 'INPUT' ||
    activeElement.tagName === 'TEXTAREA' ||
    activeElement.isContentEditable
  );
};

export function useAltPageNav() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!event.altKey || event.ctrlKey || event.metaKey) return;

      const pageIndex = Number(event.key) - 1;
      if (
        !Number.isInteger(pageIndex) ||
        pageIndex < 0 ||
        pageIndex >= ALL_NAV_PAGES.length
      ) {
        return;
      }
      if (isEditableFocused()) return;

      event.preventDefault();
      navigate(ALL_NAV_PAGES[pageIndex].path);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);
}
